
export const CUSTOM_ROUTE_MOBILE_MAP = {
  back: 'back',
  planner: 'planner',
  map: 'map',
  chatbot: 'chatbot',
  more: 'more',
  save_recommended_route_tech_mode: 'save_recommended_route_tech_mode',
  share: 'share'
} as const;